import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type PatchBetLimitsTierPayload = {
  user_id: string;
  tier: string;
};

export type PatchBetLimitsTierResponse = {
  message?: string;
  [key: string]: unknown;
} | null;

const patchBetLimitsTier = async ({
  user_id,
  tier,
}: PatchBetLimitsTierPayload): Promise<PatchBetLimitsTierResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.patch(
    API_ROUTES.UPDATE_USER_BET_LIMITS_TIER.replace("{user_id}", user_id),
    { tier },
  );

  return response?.data ?? null;
};

export const usePatchBetLimitsTier = () =>
  useMutation<PatchBetLimitsTierResponse, Error, PatchBetLimitsTierPayload>({
    mutationKey: ["patchBetLimitsTier"],
    mutationFn: patchBetLimitsTier,
  });
